/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-27 13:07:40
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-27 12:16:58
 */

import { utils } from '../../devUtils';

export const FETCH_YSC_TRANSACTION_LIMIT = '/YscTransactionLimits/FETCH_YSC_TRANSACTION_LIMIT';
export const UPDATE_YSC_TRANSACTION_LIMIT = '/YscTransactionLimits/UPDATE_YSC_TRANSACTION_LIMIT';
export const DEFAULT_ACTION = '/DEFAULT_ACTION';
export const PER_DAY_LIMIT = 'Per Day Limit';
export const PER_TRANSACTION_LIMIT = 'Per Transaction Limit';
export const GENERATE_OTP = '/YscTransactionLimits/GENERATE_OTP';

const CALCULATE_BALANCE = (cardData, id) => {
  const {
    card_info: {
      ProductInfo = {},
      ProductInfo:
      {
        Details = {},
        Details: {
          Amount = '',
        } = {},
      } = {},
    } = {},

    CardType = '',
    amount = '',
    MultipurposeCard = false,
  } = cardData;
  if (['Virtual', 'Physical'].includes(CardType) && ['physical', 'virtual'].includes(id)) {
    return amount;
  } else if (ProductInfo) {
    if (MultipurposeCard === true) {
      let temp = 0;
      Details.forEach(({ Amount: detailsAmount }) => {
        temp += parseFloat(detailsAmount);
      });
      return utils.roundNumber(temp);
    }
    return Amount;
  }
  return '- -';
};


const LIMIT_VALIDATION_MESSAGE = 'per day limit should be greater than or equal to per transaction limit';

export { CALCULATE_BALANCE, LIMIT_VALIDATION_MESSAGE };



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/constants.js